export const CERTIFICATE_TYPE = {
  CAR: 'CAR', // 车证
  CONSTRUCTION: 'CONSTRUCTION' // 施工证
}

export const CERTIFICATE_TYPE_ = {
  CAR: '车证',
  CONSTRUCTION: '施工证'
}
export const CERTIFICATE_STATUS = { // 证件申请状态
  DRAFT: '草稿',
  PENDING: '审核中',
  REJECTED: '已拒绝',
  PASS: '已通过',
  ENABLED: '已生效',
  PARTIAL_PASS: '部分通过',
  NOT_PASS: '未通过'
}

export const CERTIFICATE_CONDITION = { // 证件状态
  INVALID: '未生效',
  VALID: '已生效',
  NULLIFY: '已作废'
}

export const PAY_METHOD_MAP = {
  WXPAY_MP: '微信支付', // * 微信小程序
  WXPAY_NATIVE: '微信支付', // * 微信二维码
  ALIPAY_PC: '支付宝支付',
  REMITTANCE: '转账汇款'
}

export const PAY_METHOD_ENUM = {
  WXPAY_MP: 'WXPAY_MP',
  WXPAY_NATIVE: 'WXPAY_NATIVE',
  ALIPAY_PC: 'ALIPAY_PC',
  REMITTANCE: 'REMITTANCE'
}

export const CERTIFICATE_PAY_CONFIG_ENUM = {
  LICENSE_CUSTOM_PAY_ENABLED: 'LICENSE_CUSTOM_PAY_ENABLED', // 前台开启支付
  LICENSE_ADMIN_PAY_ENABLED: 'LICENSE_ADMIN_PAY_ENABLED', // 展馆后台开启支付
  LICENSE_CUSTOM_PAY_WAY: 'LICENSE_CUSTOM_PAY_WAY', // 前台支付方式
  LICENSE_ADMIN_PAY_WAY: 'LICENSE_ADMIN_PAY_WAY', // 后台支付方式
  LICENSE_INVOICE_ENABLED: 'LICENSE_INVOICE_ENABLED'// 证件开票功能
}
export const CERTIFICATE_PAY_CONFIG_MAP = {
  LICENSE_CUSTOM_PAY_ENABLED: '前台开启支付功能', // 前台开启支付
  LICENSE_ADMIN_PAY_ENABLED: '后台开启支付功能', // 展馆后台开启支付
  LICENSE_CUSTOM_PAY_WAY: '前台支付方式', // 前台支付方式
  LICENSE_ADMIN_PAY_WAY: '后台支付方式', // 后台支付方式
  LICENSE_INVOICE_ENABLED: '证件开启开票功能'// 证件开票功能
}
export const SOURCE = {
  /** 服务商前台 */
  PC_CUSTOM: 'PC_CUSTOM',
  /** 展馆后台 */
  PC_ADMIN: 'PC_ADMIN',
  /** 小程序 */
  MINI_PROGRAM: 'MINI_PROGRAM',
  /** 其他系统同步 */
  SYNC: 'SYNC'
}
export const ORDER_STATUS_MAP = {
  CREATED: '已创建',
  UNPAID: '待支付',
  PAID: '已支付',
  CANCELED: '已取消'
}
export const ORDER_STATUS = {
  CREATED: 'CREATED',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  CANCELED: 'CANCELED'
}

export const sleep = (time) => {
  return new Promise(reslove => {
    setTimeout(() => {
      reslove()
    }, time)
  })
}

export const accMul = (arg1, arg2) => { // 乘法计算
  if (arg1 && arg2) {
    let m = 0; const s1 = arg1.toString(); const s2 = arg2.toString()
    try { m += s1.split('.')[1].length } catch (e) { console.log(e) }
    try { m += s2.split('.')[1].length } catch (e) { console.log(e) }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
  } else {
    return
  }
}



// WEBPACK FOOTER //
// ./src/pages/Exhibitors/utils.js